import { getAxiosInstance } from "../ApiConfig";

async function CompanyDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/CompanyDetails/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AllCompanyDetailData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllCompanyDetails`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAccountChurnAnalysis(code) {
    try {
        const response = await getAxiosInstance().get(`/accountChurnAnalysis/${code}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AllSystemRole() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/allRole`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CompanyCreate(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/saveCompanyDetails`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LicenceCreatefromSuperadmin(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createLicenseManagementFromSuperAdmin`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LicenceUpdatesfromuser(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateLicenseManagementByCustomer/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CompanyUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/CompanyDetails/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LicenceUpdatesuperAdmin(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateLicenseManagementFromSuperAdmin/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CompanyRoleList(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllCompanyRolebyCompany/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CompanyDataByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getCompanyByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CompanySubcription(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchLicenseManagementByCompany/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CompanyDelte(companyId) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/CompanyDetails/${companyId}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTargetRoles(companyId, id, type, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/getTargetRoles/${companyId}/${id}/${type}`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTargetDepartments(companyId, id, type, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/getTargetDepartments/${companyId}/${id}/${type}`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCompetitors(companyId, id, type, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/getCompetitors/${companyId}/${id}/${type}`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchCheckoutCreate(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createManualAndSubscriptionCheckout`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchSubPayment(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createOneTimeCheckout`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchSubPayment1(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createOneTimeCheckout`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchsubcriptionStatus(sessionId, licenseManagementId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getSubscriptionStatus/${sessionId}/${licenseManagementId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchPaymentStatus(sessionId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getSessionStatus/${sessionId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function licenseManagementPaymentCalculation(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/licenseManagementPaymentCalculation/${id}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateLicenseManagementForNewSubscriptionAmount(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateLicenseManagementForNewSubscriptionAmount/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchAccountInteReport(companyId, targetCompanyDomain, targetCompany, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/accountInteligence/${companyId}/${targetCompanyDomain}/${targetCompany}`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function prospectDiscovery(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/prospectDiscovery`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function saveAccountInteReport(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createAccountIntelligence`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createAccountDiscover(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createAccountDiscover`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchDomainAvaliability(accountWebsite) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAccountIntelligenceByWebsite/${accountWebsite}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAccountDiscoverByName(name) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAccountDiscoverByName?accountDiscoverName=${name}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function convertHTMLtoPDF(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/convertHTMLtoPDF`, payload, {
            responseType: "arraybuffer",
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllIntelligenceReport() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAccountIntelligenceByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllAccountDiscoverByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllAccountDiscoverByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchIntelligenceReportId(accountIntelligenceId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAccountIntelligenceById/${accountIntelligenceId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAccountDiscoverById(accountIntelligenceId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAccountDiscoverById/${accountIntelligenceId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AccountInteligienceDelte(accountIntelligenceId) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteAccountIntelligence/${accountIntelligenceId}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteAccountDiscover(accountIntelligenceId) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteAccountDiscover/${accountIntelligenceId}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllExternalKeys() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllExternalKeys`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function hunterioLeadReserach(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/getLeadsFromHunter`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function hunterioLeadDetails(companyId, email) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAddressFromHunter/${companyId}/${email}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function formatIndustryForHunter(companyId, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/formatIndustryForHunter/${companyId}`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function extractDomain(url) {
    try {
        const cleanUrl = url.trim();
        const finalUrl = cleanUrl.startsWith('http') ? cleanUrl : `https://${cleanUrl}`;
        const { hostname } = new URL(finalUrl);
        return hostname;
        // return hostname.replace(/^www\./, '');
    } catch (err) {
        return null;
    }
}
async function invoiceStatusUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateGenerateInvoice/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllVectorizePropertyByCompanyCode(companyCode) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllVectorizePropertyByCompanyCode/${companyCode}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateVectorizeProperty(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateVectorizeProperty/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllCurrencyByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCurrencyByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchLicenseManagementByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchLicenseManagementByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function saveCompanyRoles(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/saveCompanyRoles`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateCompanyRole(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCompanyRole/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findOneCompanyRoleId(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneCompanyRoleId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCompanyByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getCompanyByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteCompanyRole(id, reporties) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCompanyRole/${id}/${reporties}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createSubscriptionCheckout(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createSubscriptionCheckout`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function payPenaltyAmount(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/payPenaltyAmount`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function payExtraAmountForStanderdCustomer(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/payExtraAmountForStanderdCustomer`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSubscriptionStatus(sessionId, licenseManagementId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getSubscriptionStatus/${sessionId}/${licenseManagementId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSessionStatus(sessionId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getSessionStatus/${sessionId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateLicenseManagementForNewSubscription(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateLicenseManagementForNewSubscription/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function cancelledAnnualSubscription(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/cancelledAnnualSubscription/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function calculateDowngradePenalty(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/calculateDowngradePenalty/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllCompanyHolidaysByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllCompanyHolidaysByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findOneCompanyHolidayRule(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneCompanyHolidayRule/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteCompanyHolidaysRule(companyId) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteCompanyHolidaysRule/${companyId}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createCompanyHolidaysRule(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCompanyHolidaysRule`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateCompanyHolidaysRule(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCompanyHolidaysRule/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllLoginHistoryByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLoginHistoryByCompany`);
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchAllSystemLogByCompany(companyId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSystemLogByCompany/${companyId}`);
        return response.data;
    } catch (err) {
        throw err.response?.data?.message?.message || err.message || 'Failed to fetch system logs';
    }
}
async function createConnectedAccount(companyId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/createConnectedAccount/${companyId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createOnboardingLink(stripeAccountId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/createOnboardingLink/${stripeAccountId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    createOnboardingLink,
    createConnectedAccount,
    getAllLoginHistoryByCompany,
    createCompanyHolidaysRule,
    updateCompanyHolidaysRule,
    deleteCompanyHolidaysRule,
    findOneCompanyHolidayRule,
    getAllCompanyHolidaysByUser,
    calculateDowngradePenalty,
    payPenaltyAmount,
    cancelledAnnualSubscription,
    getAccountChurnAnalysis,
    deleteAccountDiscover,
    findAccountDiscoverById,
    findAllAccountDiscoverByUser,
    createAccountDiscover,
    findAccountDiscoverByName,
    prospectDiscovery,
    deleteCompanyRole,
    getCompanyByUser,
    findOneCompanyRoleId,
    updateCompanyRole,
    saveCompanyRoles,
    fetchLicenseManagementByUser,
    CompanyDataByUser,
    CompanyDetailData,
    AllCompanyDetailData,
    CompanyCreate,
    CompanyUpdate,
    CompanyRoleList,
    CompanySubcription,
    AllSystemRole,
    LicenceCreatefromSuperadmin,
    LicenceUpdatesuperAdmin,
    CompanyDelte,
    LicenceUpdatesfromuser,
    getTargetRoles,
    getTargetDepartments,
    getCompetitors,
    fetchCheckoutCreate,
    fetchsubcriptionStatus,
    licenseManagementPaymentCalculation,
    fetchSubPayment,
    fetchPaymentStatus,
    fetchAccountInteReport,
    saveAccountInteReport,
    fetchDomainAvaliability,
    convertHTMLtoPDF,
    fetchAllIntelligenceReport,
    fetchIntelligenceReportId,
    AccountInteligienceDelte,
    fetchAllExternalKeys,
    extractDomain,
    hunterioLeadReserach,
    hunterioLeadDetails,
    formatIndustryForHunter,
    fetchSubPayment1,
    invoiceStatusUpdate,
    findAllVectorizePropertyByCompanyCode,
    updateVectorizeProperty,
    findAllCurrencyByCompany,
    createSubscriptionCheckout,
    getSubscriptionStatus,
    updateLicenseManagementForNewSubscription,
    updateLicenseManagementForNewSubscriptionAmount,
    payExtraAmountForStanderdCustomer,
    getSessionStatus,
    FetchAllSystemLogByCompany,
}